import api from "../../api/index.js";

const state = {};

const getters = {};

const actions = {
  MemberRelationSearch({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/MemberRelation/MemberRelationSearch",
        payload,
        (res) => {
          resolve(res.Result);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
  MemberRelationLevelSearch({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/MemberRelation/MemberRelationLevelSearch",
        payload,
        (res) => {
          resolve(res.Result);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
  GetSumCommission({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/MemberRelation/GetSumCommission",
        payload,
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
  GetMemberRelationCommissionSearch2({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/MemberRelation/GetMemberRelationCommissionSearch2",
        payload,
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
  GetMemberRelationLinkCommissionSearch2({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/MemberRelation/GetMemberRelationLinkCommissionSearch2",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },
  GetMemberRelationSearch({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/MemberRelation/GetMemberRelationSearch",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },
  GetMemberLevelRelationSearch({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/MemberRelation/GetMemberLevelRelationSearch",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },
  GetBossSumCommission({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/MemberRelation/GetBossSumCommission",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },
  GetBossCommissionSearch({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/MemberRelation/GetBossCommissionSearch",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },
  
  
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations,
};
